import dayjs from 'dayjs';
import getSummarySales from './getSummarySales';

const DATE_FORMAT = 'YYYY-MM-DD';

export default function getDailySalesData(
  or = [],
  d1 = [],
  d2 = [],
  d3 = [],
  diff = 30
) {
  if (!or.length && !d1.length && !d2.length && !d3.length) return [];

  const days = new Array(diff ? diff : 1)
    .fill(null)
    .map((_, index) => dayjs().subtract(index, 'day').format(DATE_FORMAT));

  const newList = [...or, ...d1, ...d2, ...d3];

  // 날짜별 정제
  const dateList = days.reduce((acc, cur) => {
    acc[cur] = newList.filter((item) => {
      const {
        type,
        regular_payment_info,
        payment_date,
        rental_payment_info,
        payment_completion_date,
      } = item;

      let day = 0;
      if (payment_completion_date) {
        day = payment_completion_date;
      } else if (type === 'DELIVERY' || type === 'STORE_PICKUP') {
        day = payment_date;
      } else if (type === 'SUBSCRIPTION') {
        const { payment_date: regularPaymentDate } = regular_payment_info;

        day = regularPaymentDate;
      } else {
        const { payment_date: rentalPaymentDate } = rental_payment_info;

        day = rentalPaymentDate;
      }

      const formatDate = dayjs.unix(day).format(DATE_FORMAT);

      return formatDate === cur;
    });

    return acc;
  }, {});

  // 합산
  const summaryData = getSummarySales(dateList);

  return summaryData;
}
